import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { AppGlobal } from '../app.global';




@Injectable()
export class UserOrg {

    constructor(private http: HttpClient, private config: AppGlobal) {
        localStorage.setItem('usersession', JSON.stringify(new Date()));
    }

    setOrg(val: any) {
        const setorg = localStorage.setItem('userOrganization', JSON.stringify(val));
        return setorg;
    }

    getOrg() {
        const getorg = JSON.parse(localStorage.getItem('userOrganization'));
        return getorg;
    }

    removeOrg() {
        const removeorg = localStorage.removeItem('userOrganization');
        return removeorg;
    }

    setOrgName(val: any) {
        //console.log(val);
        const setorg = localStorage.setItem('userOrganizationName', JSON.stringify(val));
        return setorg;
    }

    getOrgName() {
        const getorg = JSON.parse(localStorage.getItem('userOrganizationName'));
        return getorg;
    }

    removeOrgName() {
        const removeorg = localStorage.removeItem('userOrganizationName');
        return removeorg;
    }

    setOrgImageUrl(val: any) {
        //console.log(val);
        const ImageUrl = localStorage.setItem('userOrganizationImageUrl', JSON.stringify(val));
        return ImageUrl;
    }

    getOrgImageUrl() {
        const ImageUrl = JSON.parse(localStorage.getItem('userOrganizationImageUrl'));
        return ImageUrl;
    }

    removeOrgImageUrl() {
        const ImageUrl = localStorage.removeItem('userOrganizationImageUrl');
        return ImageUrl;
    }

    setOrgType(val: any) {
        const setorg = localStorage.setItem('Org_Type', JSON.stringify(val));
        return setorg;
    }

    getOrgType() {
        const getorg = JSON.parse(localStorage.getItem('Org_Type'));
        return getorg;
    }

    removeOrgType() {
        const removeorg = localStorage.removeItem('Org_Type');
        return removeorg;
    }
}
